import React, { FC, HTMLAttributes, ReactNode } from 'react'

import classes from './InputContainer.module.scss'

interface InputContainerProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode
  margin?: number
}

const SPACING_UNIT = 8

export const InputContainer: FC<InputContainerProps> = ({
  children,
  margin = 2,
  className,
  style,
  ...rest
}) => (
  <div
    className={[classes.inputContainer, className].filter(Boolean).join(' ')}
    style={{ ...style, marginBottom: `${margin * SPACING_UNIT}px` }}
    {...rest}
  >
    {children}
  </div>
)

export default InputContainer
